import { useCustom, useTranslate } from '@refinedev/core';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { IUser } from '../interfaces/user.interface';

type Culture = 'en' | 'uk';

interface IUseUserResult {
    user: IUser | undefined;
    token: string | undefined;
    refreshToken: string | undefined;
    culture: Culture;
    isTokenReady: boolean;
    isAuthReady: boolean;
    isUserLoading: boolean;
    isLoading: boolean;
    error: any;
    handleIframeLoad: () => void;
}

export const useUser = (): IUseUserResult => {
    const t = useTranslate();
    const { i18n } = useTranslation();
    const {
        data,
        isLoading: isDataLoading,
        error,
    } = useCustom<IUser[]>({
        url: `api/auth/user`,
        method: 'get',
        errorNotification: (e: any) => ({
            message: ` ${t('notifications.an_error_occurred')}: ${e?.message}`,
            type: 'error',
        }),
    });

    const user: IUser | undefined = data?.data?.[0];
    const token = user?.pharmasol_token;
    const refreshToken = user?.pharmasol_refresh_token;
    const culture: Culture =
        i18n.language?.toLowerCase().startsWith('en') ? 'en' : 'uk';
    const isTokenReady = Boolean(token);
    const isAuthReady = Boolean(token && refreshToken);

    const [isIframeLoading, setIsIframeLoading] = useState<boolean>(true);

    const handleIframeLoad = () => {
        setIsIframeLoading(false);
    };

    return {
        user,
        token,
        refreshToken,
        culture,
        isTokenReady,
        isAuthReady,
        isUserLoading: isDataLoading,
        isLoading: (isDataLoading || isIframeLoading) && isTokenReady,
        error,
        handleIframeLoad,
    };
};
